import React from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Welcome from "@/pages/Welcome";
import About from "@/pages/About";
import Simulation from "@/pages/Simulation";
import Admin from "@/pages/Admin";
import References from "@/pages/References";
import CodeScribe from "@/pages/CodeScribe";
import { ConfirmProvider } from "@/components/ConfirmProvider";

function App() {
  return (
    <div className="App">
      <ConfirmProvider>
        <BrowserRouter>
          <Routes>
            <Route path="/" element={<Welcome />} />
            <Route path="/about" element={<About />} />
            <Route path="/sim" element={<Simulation />} />
            <Route path="/code" element={<CodeScribe />} />
            <Route path="/refs" element={<References />} />
            <Route path="/admin" element={<Admin />} />
          </Routes>
        </BrowserRouter>
      </ConfirmProvider>
    </div>
  );
}

export default App;
